import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';
import css from './index.module.scss';

const G: React.FC = () => {
    const { t } = useLang('stream_ultra_x');
    return (
        <section
            className={`${css.section} stream-ultra-x-G GtmModuleData-section`}
            id="stream-ultra-x-G"
            data-section-id={'stream-ultra-x-G'}
            data-section-title={t('G_title')}
        >
            <EcoImg
                pc="https://websiteoss.ecoflow.com/upload/image/1753666625024/7.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1753666648585/7_M.jpg"
                isOpenLazy={true}
            />
            <div className="info">
                <p className="title">{t('G_title')}</p>
                <p className="desc">{t('G_desc')}</p>
            </div>
            <div className="position-block" id="stream-ultra-x-G-position"></div>
        </section>
    );
};

export default G;
